// extracted by mini-css-extract-plugin
module.exports = {"caption":"StatusCaption_caption__5fW5q","captionlight":"StatusCaption_captionlight__3vq-c","captiondark":"StatusCaption_captiondark__17EuR"};